import React from 'react';
import { StyledWrapper, BGWrapper } from '../Styled';

interface IWrapper {
  children: React.ReactNode;
  color?: string;
}

export const Wrapper: React.FC<IWrapper> = (props): JSX.Element => {
  const { children, color } = props;
  return (
    <>
      {color ? (
        <BGWrapper data-testid="bg-wrapper" color={color}>
          <StyledWrapper>{children}</StyledWrapper>
        </BGWrapper>
      ) : (
        <StyledWrapper>{children}</StyledWrapper>
      )}
    </>
  );
};
